import moment from 'moment-timezone';
import { ActionId, CaptureInput } from './Data'
import { TaskId } from 'Tasks/Data';
import { ActionCreatorThunk } from 'Store';
import { withNS, ActionType, NSAction } from './Action';
import { actionStatusesFromJSON } from './JSON';

export interface ActionCreators {
  clearActionStatuses(): NSAction,
  loadActionStatuses(date: moment.Moment): ActionCreatorThunk
  completeTaskAction(
    taskId: TaskId, time: moment.Moment, input?: CaptureInput
  ): ActionCreatorThunk
  undoTaskAction(date: moment.Moment, actionId: ActionId): ActionCreatorThunk
}

export const ActionCreators: ActionCreators = {
  clearActionStatuses,
  loadActionStatuses,
  completeTaskAction,
  undoTaskAction
};

function clearActionStatuses(): NSAction {
  return withNS({ type: ActionType.CLEAR_ACTION_STATUSES });
}

function loadActionStatuses(date: moment.Moment): ActionCreatorThunk {
  return async (dispatch, _, { api }) => {
    dispatch(withNS({
      type: ActionType.LOAD_ACTION_STATUSES__BEGIN,
      date
    }));

    try {
      const result = await api.carePlans.getActionStatuses(date);
      const statuses = actionStatusesFromJSON(result.action_statuses);

      dispatch(withNS({
        type: ActionType.LOAD_ACTION_STATUSES__SUCCESS,
        dailyStatus: { date, statuses }
      }));
    } catch (e) {
      dispatch(withNS({
        type: ActionType.LOAD_ACTION_STATUSES__ERROR
      }));
    }
  }
}

function completeTaskAction(
  taskId: TaskId, time: moment.Moment, input?: CaptureInput
): ActionCreatorThunk {
  return (_dispatch, _getState, { api }) =>
    api.carePlans.completeTaskAction(taskId, time, input);
}

function undoTaskAction(
  date: moment.Moment, actionId: ActionId
): ActionCreatorThunk {
  return (_dispatch, _getState, { api }) =>
    api.carePlans.undoTaskAction(date, actionId);
}
